import React from "react";
import { Col, Row } from "react-bootstrap";
import ButtonComponent from "../../components/ButtonComponent";
import { useNavigate } from "react-router-dom";
// import readyToFeast from "../../assets/images/ReadytoFeast2.PNG";
import readyToFeast from "../../assets/images/ReadytoFeast3.PNG";
import ContactInfoButton from "../../components/EmailButtonComponent";
import EmailSVG from "../../assets/icons/emailIcon.PNG";
import PhoneSVG from "../../assets/icons/phoneIcon.PNG";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightDots } from "@fortawesome/free-solid-svg-icons";

const Documents = () => {
  const navigate = useNavigate();
  const handlePrivacyPolicyClick = () => {
    navigate("/privacy-policy");
  };
  const handleTermsOfServiceClick = () => {
    navigate("/terms-of-service");
  };
  // const handleTermsOfSaleClick = () => {
  //   navigate("/terms-of-sale");
  // };
  const handleRefundPolicyClick = () => {
    navigate("/refund-policy");
  };
  const handlePaymentPolicyClick = () => {
    navigate("/payment-policy");
  };
  const handleCookieTrackingPolicyClick = () => {
    navigate("/cookie-tracking-policy");
  };
  const handleContactComplainPolicyClick = () => {
    navigate("/contact-complain-policy");
  };
  const handleDataProtectionPolicyClick = () => {
    navigate("/data-protection-policy");
  };
  const handleIosPrivacyPolicyClick = () => {
    navigate("/ios-privacy-policy");
  };
  return (
    <>
    <div className="container mt-5 mb-5 py-4">
      <h1 className="fw-bold">Our Policies</h1>
      <p>
        Curry King (Private) Limited is committed to ensuring transparency,
        safety, and trust in every interaction. Below you will find links to our
        official policies, which govern the use of our website, mobile
        applications, and food services. Each document reflects our commitment
        to regulatory compliance, customer rights, and responsible business
        practices.
      </p>
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Privacy Policy</h5>
        </Col>
        <Col>
          <p>
            Learn how we collect, use, and protect your personal information
            when you interact with our website, apps, and services.
          </p>
          <ButtonComponent
            title="View Privacy Policy"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handlePrivacyPolicyClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Data Protection Policy</h5>
        </Col>
        <Col>
          <p>
            An overview of our internal practices and safeguards to ensure the
            security, confidentiality, and lawful processing of personal data.
          </p>
          <ButtonComponent
            title="View Data Protection Policy"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handleDataProtectionPolicyClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Terms of Service</h5>
        </Col>
        <Col>
          <p>
            The legal agreement that outlines your rights and responsibilities
            when using our services, placing orders, and interacting with our
            platform.
          </p>

          <ButtonComponent
            title="View Terms of Service"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handleTermsOfServiceClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Refund & Cancellation Policy</h5>
        </Col>
        <Col>
          <p>
            Details the conditions under which orders can be cancelled, refunds
            can be requested, and the process for handling exceptions.
          </p>

          <ButtonComponent
            title="View Refund & Cancellation Policy"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handleRefundPolicyClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Payment Policy</h5>
        </Col>
        <Col>
          <p>
            Outlines the accepted payment methods, timing, refund processing,
            and terms related to promotional discounts.
          </p>

          <ButtonComponent
            title="View Payment Policy"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handlePaymentPolicyClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Delivery & Pickup Policy</h5>
        </Col>
        <Col>
          <p>
            Explains how our food delivery and cart pickup services operate,
            including delivery zones, timing, and customer responsibilities.
          </p>

          <ButtonComponent
            title="View Delivery & Pickup Policy"
            color="#fff"
            backgroundColor="#000"
           icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Cookie and Tracking Policy</h5>
        </Col>
        <Col>
          <p>
            Describes how we use cookies and tracking technologies to improve
            your experience and ensure service performance.
          </p>

          <ButtonComponent
            title="View Cookie and Tracking Policy"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handleCookieTrackingPolicyClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={4} md={4} sm={12} className="mb-3">
          <h5 className="fw-bold">Contact & Complaint Policy</h5>
        </Col>
        <Col>
          <p>
            Information on how to reach our support team and how we handle
            customer feedback, inquiries, and complaints
          </p>

          <ButtonComponent
            title="View Contact & Complaint Policy"
            color="#fff"
            backgroundColor="#000"
            icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
            onClick={handleContactComplainPolicyClick}
          />
        </Col>
      </Row>
      <hr />
      <Row>
          <Col lg={4} md={4} sm={12} className="mb-3">
            <h5 className="fw-bold">IOS Privacy Policy</h5>
          </Col>
          <Col>
            <p>
              Information on how we handle user data, privacy rights, and
              compliance with IOS guidelines.
            </p>

            <ButtonComponent
              title="View IOS Privacy Policy"
              color="#fff"
              backgroundColor="#000"
              icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
              onClick={handleIosPrivacyPolicyClick}
            />
          </Col>
        </Row>
        <hr />
      </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 position-relative">
              <div className="ready-to-feast-image-wrapper">
                <img
                  src={readyToFeast}
                  alt="Ready to Feast"
                  className="img-fluid rounded-3 mb-4"
                />

                <div className="overlay-text text-white text-center">
                  <h1 className="display-4 fw-bold">We’re Always there for you</h1>
                  <p className="lead">
                    If you have any questions regarding these policies or require further clarification, please contact us at:
                  </p>
                  <div className="contact-button-row mb-3 ">
                    <ContactInfoButton
                      icon={EmailSVG}
                      title="Email Us"
                      subtitle="support@curryking.lk"
                    />
                    <ContactInfoButton
                      icon={PhoneSVG}
                      title="Call for Information"
                      subtitle="+94 11 444 1333"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default Documents;